import type { Breadcrumb } from './workspace-nav.js';

/** Название приложения — хвост любого заголовка вкладки (как в `index.html`). */
export const APP_TITLE = 'WIT Admin';

/**
 * Заголовок вкладки браузера из хлебных крошек: от частного к общему, через
 * «·», с названием приложения в конце — «Сводка · Окупаемость · WIT Admin».
 *
 * Первая крошка (пространство) опускается, если есть что-то кроме неё: во
 * вкладке важнее экран, а пространство и так видно в админке. Подряд идущие
 * одинаковые подписи схлопываются. Пустые крошки — просто «WIT Admin».
 */
export function documentTitleFor(crumbs: readonly Breadcrumb[]): string {
  const meaningful = (crumbs.length > 1 ? crumbs.slice(1) : crumbs)
    .map((c) => c.label.trim())
    .filter((l) => l.length > 0);
  const parts: string[] = [];
  for (const label of [...meaningful].reverse()) {
    if (parts[parts.length - 1] !== label) parts.push(label);
  }
  return [...parts, APP_TITLE].join(' · ');
}
